import * as mainTerms from '../mainTerms';

const campaign = mainTerms.Setting.campaign.default;
const inventory = mainTerms.Setting.inventory.default;
const impression = mainTerms.Other.impression;
export const Dashboard = {
    Title: 'Dashboard',
    GroupExplanation: [
        '최근 데이터를 간략히 조회합니다.',
        '설정 현황을 조회합니다.',
        '예산 소진 현황을 조회합니다.',
    ],
    dashboard: mainTerms.Dashboard.dashboard.title,
    campaignLive: mainTerms.Dashboard.campaignLive.title,
    budget: mainTerms.Dashboard.budget.title,
};

export const Setting = {
    Title: '설정 및 관리',
    GroupExplanation: [
        campaign + ' 등을 설정하고 확인합니다',
    ],
    campaign: mainTerms.Setting.campaign.title,
    audience: mainTerms.Setting.audience.title,
    adFolder: mainTerms.Setting.adFolder.title,
    inventory: mainTerms.Setting.inventory.title,
    partner: mainTerms.Setting.partner.title,
    advertiser: mainTerms.Setting.advertiser.title,
};

export const Report = {
    Title: '리포트',
    GroupExplanation: [
        campaign + ' 관련 리포트를 조회합니다.',
        '매출을 조회하고, 비교합니다.',
        inventory + ' 리포트를 기간별로 조회합니다.',
        impression + ' 예측량을 조회합니다.',
        'SSP 리포트 페이지로 이동합니다.',
    ],
    campaign: mainTerms.Report.campaign.title,
    campaignWeight: mainTerms.Report.campaignWeight.title,
    sales: {
        monthly: mainTerms.Report.sales.monthly.title,
    },
    inventory: {
        hourly: mainTerms.Report.inventory.hourly.title,
        daily: mainTerms.Report.inventory.daily.title,
        monthly: mainTerms.Report.inventory.monthly.title,
    },
    ai: mainTerms.Report.ai.title,
    ssp: 'SSP 리포트',
};
